import "./signin.css";

export default function SignInPage() {
    return <>
        <form className="signin-center-frame">
            <h2>Вход в аккаунт</h2>
            <p>E-Mail:</p>
            <input type="email" />
            <p>Пароль:</p>
            <input type="password" />
            <input type="submit" value="Войти в аккаунт" className="signin-btn"/>
            <p>Забыли пароль? <a href="/password-recovery">Восстановить</a></p>
            <p>Нет аккаунта? <a href="/signup">Создать</a></p>
        </form>
    </>
}